module.exports = __webpack_public_path__ + "img/red_076.5f75b934.png";